import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  message,
  Row,
  Space,
  Table,
  notification,
  Tooltip,
  Switch,
  Modal,
  Form,
} from "antd";
import { FaSliders } from "react-icons/fa6";
import IMAGES from "../../const/Image";
import policyRequest from "../Policy/PolicyRequest";

const initialFilter = { page: 1 };

export const PanaltyStructure = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredPanaltyStructure, setFilteredPanaltyStructure] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const showConfirm = Modal.confirm;

  // Fetch filtered booking status
  const fetchPanaltyStructureFilterList = () => {
    setLoading(true);
    policyRequest
      .panaltyStructureFilteredList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        const totalCount = response?.data?.data?.totalItems || 0;
        setFilteredPanaltyStructure(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch Terms & Conditions.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPanaltyStructureFilterList();
  }, [filter]);

  // Handle filter changes
  const handleFilter = () => {
    setFilter({ ...filter, ...filterForm, page: 1 });
    setIsModalOpen(false);
  };

  // Handle pagination changes
  const handleChange = (pagination) => {
    setFilter({ ...filter, page: pagination.current });
  };

  // Reset filters
  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (_, item, index) => (filter.page - 1) * 10 + index + 1,
    },
    { title: "Content", dataIndex: "content", key: "content" },
    { title: "Version", dataIndex: "versionNumber", key: "versionNumber" },
    {
      title: "EffectiveDate",
      dataIndex: "effectiveDate",
      key: "effectiveDate",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      width: 120,
      align: "center",
      render: (isActive, item) => (
        <Switch
          checked={isActive}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {record.isActive && (
            <Tooltip title="Edit Details">
              <span
                className="action-icon-bg"
                onClick={() =>
                  navigate(`/panaltyStructures/update/${record.id}`)
                }
              >
                <img src={IMAGES.EditIcon} alt="Edit" />
              </span>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  // Handle status change (active/inactive)
  const handleStatusChange = (checked, item) => {
    if (!item.id) {
      notification.error({
        message: "Booking Id is required to update status.",
      });
      return;
    }
    // Modal.confirm({
    //     title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this booking?`,
    //     okText: "Yes",
    //     cancelText: "No",
    //     onOk() {
    //         setLoading(true);
    //         bookingStatusRequest.activeInactiveBookingStatus({ isActive: checked, id: item.id })
    //             .then((res) => {
    //                 if (res && res.status === 200) {
    //                     notification.success({ message: "Booking Status updated successfully" });
    //                     fetchBookingStatusFilterList();
    //                 } else {
    //                     notification.error({ message: "Failed to update status" });
    //                 }
    //             })
    //             .catch(() => {
    //                 notification.error({ message: "Failed to update status" });
    //             })
    //             .finally(() => {
    //                 setLoading(false);
    //             });
    //     },
    // });
  };

  return (
    <>
      <div>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Panalty Structure List</h1>
          </Col>
          <Col>
            <div style={{ display: "flex", gap: "1rem" }}>
              {/* <Button onClick={showModal} type="primary" className="addcity-btn">
                                <FaSliders />
                            </Button>
                            <Button onClick={resetFilters} type="primary" className="addcity-btn">Reset</Button> */}
              {filteredPanaltyStructure.length === 0 && (
                <Button
                  onClick={() => navigate("/panaltyStructures/add")}
                  type="primary"
                  className="addcity-btn"
                >
                  <img src={IMAGES.AddIconFilters} alt="Add" />
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>

      <Table
        size="middle"
        bordered
        rowClassName="row-class"
        columns={columns}
        loading={loading}
        dataSource={filteredPanaltyStructure}
        pagination={{
          total: totalRecords,
          current: filter.page,
          defaultCurrent: 1,
        }}
        onChange={handleChange}
      />
    </>
  );
};
